import centsToCurrency from 'cents-to-currency';
import { formatInt } from './formatIntToCurrency';

export const formatCurrency = (currency = 'BRL', value) => {
  try {
    if (!value) return null;
    if (value === undefined) return null;
    return centsToCurrency(value.replace(/\D+/g, ''), currency);
  } catch (error) {
    return centsToCurrency(value, currency);
  }
};

export const formatCurrencyToApiString = string => {
  if (!string) return '000';
  return string.replace(/(\D)/g, '');
};

export const formatCurrencyToFront = (value, local = 'pt-br') => {
  if (!value) return;

  const currencyFormat = value / 100;
  return currencyFormat.toLocaleString(local, { minimumFractionDigits: 2 });
};
